import { useConfirm } from "primevue";
import { useActionFailedAlert } from "shared/problems/composables/actionFailedAlert";
import { useGetLogSorterById } from "../api/getLogSorterById";
import { useDeleteLogSorter } from "../api/deleteLogSorter";
import { useDeleteStorageArea } from "@/storageAreas/api/deleteStorageArea";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export function useDeleteLogSorterConfirm() {
  const confirm = useConfirm();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const getLogSorter = useGetLogSorterById();
  const actionFailedAlert = useActionFailedAlert();
  const deleteLogSorter = useDeleteLogSorter();
  const deleteStorageArea = useDeleteStorageArea();

  return {
    show
  };

  async function show(options: ShowConfirm) {
    const logSorterId = options.logSorterId;

    const response = await getLogSorter.execute({ logSorterId: logSorterId });

    if (!response.ok) {
      actionFailedAlert.show(response.details);
      return;
    }

    const logSorter = response.logSorter;

    const promise = new Promise<boolean>((resolve, reject) => {

      confirm.require({
        message: translations.value.logSorter.deleteConfirm.message(logSorter.name),
        header: translations.value.logSorter.deleteConfirm.title,
        icon: "pi pi-info-circle",
        rejectProps: {
          label: translations.value.generic.abort,
          severity: "secondary",
          outlined: true,
        },
        acceptProps: {
          label: translations.value.generic.delete,
          severity: "danger",
        },
        accept: async () => {
          try {

            for (const bin of logSorter.bins) {
              const storageAreaId = bin.storageAreaId;
              const deleteStorageAreaResponse = await deleteStorageArea.execute({ storageAreaId });
              if (!deleteStorageAreaResponse.ok) {
                actionFailedAlert.show(deleteStorageAreaResponse.details);
                resolve(false);
                return;
              }
            }

            const response = await deleteLogSorter.execute({ logSorterId: logSorterId });

            if (!response.ok) {
              actionFailedAlert.show(response.details);
              resolve(false);
              return;
            }

            resolve(true);

          } catch {
            reject();
          }
        },
        reject: () => {
          resolve(false);
        }
      });
    });

    return promise;
  }
}

interface ShowConfirm {
  logSorterId: number;
}
